exports.list = {
    path: '/laporan_pemasukan_consumable',
    name: 'laporan_pemasukan_consumable_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/laporan_pemasukan_consumable/List.vue"),
}